

<span *ngIf="inPageNav && inPageNav=='Low'" class="risk-label gds-status-tag low">{{inPageNav}}</span>
<span *ngIf="inPageNav && inPageNav=='Medium'" class="risk-label gds-status-tag medium">{{inPageNav}}</span>
<span *ngIf="inPageNav && inPageNav=='High'" class="risk-label gds-status-tag high">{{inPageNav}}</span>
<span *ngIf="inPageNav && inPageNav=='Very High'" class="risk-label gds-status-tag very-high">{{inPageNav}}</span>

<!-- <span class="risk-label gds-status-tag high">HIGH</span> -->